<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf="legendVisible">
    <!-- full desktop -->
    <mat-toolbar fxLayout='row' fxLayoutAlign='space-between center'>
        <span>{{ siteName$ | async }}</span>
        <div *ngIf='!(isDefaultUser$ | async)' fxLayout='row' fxLayoutAlign='end center'>
            <button mat-icon-button
                    matTooltip="Reset Layer Visibility"
                    (click)='resetLayers()'>
                <mat-icon class="mat-icon-button" [svgIcon]="'reset'"></mat-icon>
            </button>
            <button mat-icon-button matTooltip="Save Current Layer Visibility" (click)='saveLayers()'>
                <mat-icon class="mat-icon-button" [svgIcon]="'save'"></mat-icon>
            </button>
        </div>
    </mat-toolbar>
    <dash-gis-map-legend-container></dash-gis-map-legend-container>
</ng-container>

